import benefitInspectionImage from '@stack/assets/images/consignment/consignment-benefit-1.png';
import benefitMoneyBackImage from '@stack/assets/images/consignment/consignment-benefit-2.png';
import benefitWarrantyImage from '@stack/assets/images/consignment/consignment-benefit-3.png';
import benefitNoHiddenChargeImage from '@stack/assets/images/consignment/consignment-benefit-4.png';

export const CONSIGNMENT_BENEFITS = [
  {
    imageSrc: benefitInspectionImage.src,
    label: 'Approved 200-Check Points Inspection',
  },
  {
    imageSrc: benefitMoneyBackImage.src,
    label: '7 Day Money Back Guarantee',
  },
  {
    imageSrc: benefitWarrantyImage.src,
    label: 'One Year Extended Warranty',
  },
  {
    imageSrc: benefitNoHiddenChargeImage.src,
    label: 'No Hidden Charge',
  },
];
